const countryToggleConfig = countryCode => ({
  hideDepositElanLaw: ['FR'].includes(countryCode),
  moveLandlordPoliciesToPricing: ['BE'].includes(countryCode),
  isUnderFeesAndExpensesExperiment: ['ES', 'IT'].includes(countryCode)
});

export default countryToggleConfig;
